import AddToPantryModal from './add_to_pantry_modal'

export default AddToPantryModal